import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {CommonModule} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {httpAuthInterceptorProvider} from "./interceptors/auth.interceptor";
import {httpCachingInterceptorProviders} from "./interceptors/token-caching.interceptor";
import {httpTokenRefreshInterceptorProvider} from "./interceptors/refresh-token.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom([
      CommonModule,
      BrowserAnimationsModule,
    ]),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    httpAuthInterceptorProvider,
    httpCachingInterceptorProviders,
    httpTokenRefreshInterceptorProvider
  ]
};
